import {useQuery} from '@tanstack/react-query';
import {api} from '@/shared/services/api-client';
import {queryKeys} from '@/lib/query-keys';
import type {HistoryEntry} from '@/shared/types/history';

/**
 * Fetch a project's email template change-log (Email Setup "History" tab,
 * OD-1146). The endpoint already returns entries newest-first.
 */
export async function fetchEmailTemplateHistory(projectId: string): Promise<HistoryEntry[]> {
  const res = await api.projects.getEmailTemplateHistory(projectId);
  const data = res?.data?.data ?? res?.data ?? [];
  return Array.isArray(data) ? (data as HistoryEntry[]) : [];
}

export function useEmailTemplateHistoryQuery(params: {
  projectId?: string | null;
  enabled?: boolean;
}) {
  const {projectId, enabled = true} = params;
  return useQuery({
    queryKey: queryKeys.history.forEmailTemplates(String(projectId ?? '')),
    queryFn: () => fetchEmailTemplateHistory(String(projectId)),
    enabled: Boolean(enabled && projectId),
    staleTime: 30_000,
    // Avoid flicker: history is append-only and invalidated on mutations, so a
    // background refetch on window-focus only risks a transient loading flash.
    refetchOnWindowFocus: false,
  });
}
